<div class="Done-wrapper">
    <div class="done-wrapper-inner">
        <h1>Thank you for submitting your content. Your website will be ready within the next 24 hours.</h1>
        <div>
            <a routerLink="/">
            <button class="reset-btn" mat-button ><span class="lnr lnr-save"></span> Go Back</button></a>
        </div>
    </div>
</div>